import React from 'react';
import T from 'prop-types';

import PageNav from '../PageNav';
import skeletons from '../Skeletons';
import Button from '../../../../../../components/Buttons/Button';

import { truncateTicker } from '../../../../../../utils/helpers';

const ForecastsReportsHeader = ({
  pending,
  activeTab,
  forecasts,
  availableKpis,
  activeForecast,
  quartersDropdown,
  downloadButton,
  onTabChange,
}) => {
  const {
    company_id,
    bloomberg_ticker,
  } = activeForecast?.forecasts || {};

  return (
    <>
      <div className="card-box__head forecasts-header">
        <div className="card-box__head-left">
          {pending
            ? skeletons.forecastHeader
            : (
              <PageNav
                pagesList={availableKpis || forecasts}
                active={activeTab}
                onChange={onTabChange}
              />
            )}
        </div>
        <div className="card-box__head-right" />
      </div>
      <div className="forecasts-filters">
        {pending
          ? skeletons.forecastsFilters
          : (
            <>
              {quartersDropdown}
              {downloadButton}
              <Button // TODO: add CQV if needed
                variant="secondary"
                href={`/companies/${company_id}`}
                className="ml-auto"
              >
                {`View Company (${truncateTicker(bloomberg_ticker)?.toUpperCase()})`}
                <i className="hicon-angle-right-new" />
              </Button>
            </>
          )}
      </div>
    </>
  );
};

ForecastsReportsHeader.propTypes = {
  pending: T.bool.isRequired,
  activeTab: T.string,
  forecasts: T.array,
  availableKpis: T.array,
  activeForecast: T.object,
  quartersDropdown: T.node,
  downloadButton: T.node,
  onTabChange: T.func.isRequired,
};

export default ForecastsReportsHeader;
